import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm]       = useState({ name: "", email: "", password: "", role: "student" });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const pw = form.password;
  const rules = [
    { key: "len",   label: "至少 8 個字元",     ok: pw.length >= 8 },
    { key: "upper", label: "包含大寫英文字母", ok: /[A-Z]/.test(pw) },
    { key: "lower", label: "包含小寫英文字母", ok: /[a-z]/.test(pw) },
    { key: "digit", label: "包含數字",         ok: /[0-9]/.test(pw) },
  ];
  const allValid = rules.every(r => r.ok);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!allValid) { setError("密碼不符合規則，請確認下方提示"); return; }
    setLoading(true);
    try {
      await register(form.email, form.password, form.name, form.role);
      navigate("/verify-pending", { state: { email: form.email } });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24,
    }}>
      <div className="card fade-up" style={{ width: "100%", maxWidth: 420, padding: 40 }}>

        <div style={{ marginBottom: 32, textAlign: "center" }}>
          <h1 style={{ fontSize: 32, marginBottom: 8 }}>建立帳號</h1>
          <p style={{ color: "var(--muted)" }}>加入 馭雪 · YUXUE，找到最適合你的教練</p>
        </div>

        {error && (
          <div style={{
            background: "#FEF2F2", border: "1px solid #FECACA",
            color: "var(--red)", borderRadius: 8, padding: "12px 16px",
            marginBottom: 20, fontSize: 14,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 6, color: "var(--ink2)" }}>姓名</label>
            <input className="input-field" type="text" placeholder="你的姓名"
              value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 6, color: "var(--ink2)" }}>Email</label>
            <input className="input-field" type="email" placeholder="your@email.com"
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 6, color: "var(--ink2)" }}>密碼</label>
            <input className="input-field" type="password" placeholder="至少 8 個字元"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
            <ul className="pw-rules">
              {rules.map(r => (
                <li key={r.key} className={`pw-rule ${r.ok ? "ok" : ""}`}>
                  <span className="dot">{r.ok ? "✓" : ""}</span>{r.label}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 8, color: "var(--ink2)" }}>身份</label>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {[
                { value: "student", label: "學生", desc: "尋找教練課程" },
                { value: "coach",   label: "教練", desc: "提供教學服務" },
              ].map(opt => (
                <div
                  key={opt.value}
                  onClick={() => setForm({ ...form, role: opt.value })}
                  style={{
                    border: `1.5px solid ${form.role === opt.value ? "var(--ink)" : "var(--stone)"}`,
                    borderRadius: 8, padding: "12px 14px", cursor: "pointer",
                    background: form.role === opt.value ? "var(--off)" : "var(--white)",
                    transition: "all .15s",
                  }}
                >
                  <div style={{ fontWeight: 500, fontSize: 14 }}>{opt.label}</div>
                  <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>{opt.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-full"
            style={{ marginTop: 8, height: 48 }} disabled={loading || !allValid}>
            {loading ? <span className="spinner" style={{ borderTopColor: "var(--white)" }} /> : "建立帳號"}
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: 24, color: "var(--muted)", fontSize: 14 }}>
          已有帳號？{" "}
          <Link to="/login" style={{ color: "var(--ink)", fontWeight: 500, textDecoration: "underline" }}>
            登入
          </Link>
        </p>
      </div>
    </div>
  );
}